module.exports = __webpack_public_path__ + "static/media/rice-other-grains.ac3e37be.webp";